export default __webpack_public_path__ + "static/media/landing_background.b94469c3.jpg";